// extracted by mini-css-extract-plugin
export default {"chatPageChat5":"Chat5_chatPageChat5__bF4ZM"};